import React, { Fragment, useEffect, useMemo, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';

import { Assignment, Check } from '@material-ui/icons';

import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import Table from 'components/Table/Table';
import styles from 'assets/jss/material-dashboard-pro-react/views/regularFormsStyle';

import { TextField, FormControlLabel, Checkbox, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import { wsFindBy } from 'services/WService.js';
import { wsUpdate } from 'services/WService';

const useStyles = makeStyles({
  ...styles,
  tableCell: {
    padding: '6px 8px!important',
  },
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
  addButton: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
});

export default function ZoneCanal(props) {
  const classes = useStyles();
  const [restrictions, setRestrictions] = useState([]);
  const [selectedCanal, setSelectedCanal] = useState('T');

  const filteredRestrictions = useMemo(() => {
    if (restrictions.length === 0) return restrictions;
    if(selectedCanal === 'T') return restrictions;
    return restrictions.filter(item => item.base_canal_id === selectedCanal);
  }, [restrictions, selectedCanal]);

  const promotion = props.promotion;
  const showNotify = props.showNotify;

  const statePromo = promotion.state == 'N' || promotion.state == 'G' ? false : true;

  async function listRestrictions() {
    let response = await wsFindBy('prom/restriction', 'prom_promotion_id', promotion.id);
    if (response.success) {
      setRestrictions(
        response.data?.sort((a, b) => b.canal_description.localeCompare(a.canal_description)),
      );
      if (response.data.length > 0) props.setCurrentRest(true);
    }
  }

  const [dataZone, setDataZone] = useState();
  const handleChange = (e, idRestriction) => {
    let name = e.target.name;
    let value = e.target.value;
    setRestrictions(restrictions => {
      let newRestrictions = [...restrictions];
      let index = newRestrictions.findIndex((item) => item.id === idRestriction);
      if(index !== -1){
        newRestrictions[index][`updated_${name}`] = value;
      }
      return newRestrictions;
    });
  };

  async function updateRestrinction(idRestrinction, state) {
    let response = await wsUpdate('prom/restriction', idRestrinction, {
      state,
    });
    if (response.success) {
      listRestrictions();
      showNotify(response.message);
    } else {
      showNotify(response.message, 'error');
    }
  }

  async function updateRestrinctionInd(idRestrinction, independent) {
    let response = await wsUpdate('prom/restriction', idRestrinction, {
      independent,
    });
    if (response.success) {
      listRestrictions();
      showNotify(response.message);
    } else {
      showNotify(response.message, 'error');
    }
  }

  async function saveUpdate(idRest) {
    let restriction = restrictions.find((item) => item.id === idRest);
    let data = {};
    for (let key in restriction) {
      if (key === 'updated_at') continue;
      if (!key.startsWith('updated')) {
        continue;
      }
      let originKey = key.substring('updated_'.length, key.length);
      data[originKey] = restriction[key];
    }

    let response = await wsUpdate('prom/restriction', idRest, data);
    if (response.success) {
      listRestrictions();
      showNotify(response.message);
    } else {
      showNotify(response.message, 'error');
    }
  }

  useEffect(() => {
    if (!!promotion.id) {
      listRestrictions();
    }
  }, [promotion]);

  return (
    <GridItem xs={12}>
      <Card>
        <CardHeader color="primary" icon>
          <CardIcon color="primary">
            <Assignment />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>
            <span style={{ marginRight: '100px' }}>Zonas</span>
            <FormControl margin="normal" size="small" style={{ width: '150px' }}>
              <InputLabel>Canal</InputLabel>
              <Select value={selectedCanal} onChange={(e) => setSelectedCanal(e.target.value)}>
                <MenuItem value="T">Todos</MenuItem>
                <MenuItem value="1">Minorista</MenuItem>
                <MenuItem value="2">Mayorista</MenuItem>
              </Select>
            </FormControl>
          </h4>
        </CardHeader>
        <CardBody>
          <div style={{ overflow: 'auto' }}>
            <Table
              striped
              tableHead={[
                '#',
                'Zona',
                'Canal',
                'Avance',
                'Independiente',
                'Inicial',
                'Final',
                'Cantidad',
              ]}
              tableData={filteredRestrictions.map((restriction, i) => {
                return [
                  <Fragment>
                    <div
                      className={
                        classes.checkboxAndRadio + ' ' + classes.checkboxAndRadioHorizontal
                      }
                    >
                      <FormControlLabel
                        disabled={statePromo}
                        control={
                          <Checkbox
                            tabIndex={-1}
                            onClick={() => {
                              updateRestrinction(
                                restriction.id,
                                restriction.state == 'A' ? 'I' : 'A',
                              );
                            }}
                            checked={restriction.state == 'A' ? true : false}
                            checkedIcon={<Check className={classes.checkedIcon} />}
                            icon={<Check className={classes.uncheckedIcon} />}
                            classes={{
                              checked: classes.checked,
                              root: classes.checkRoot,
                            }}
                            style={{ marginTop: 0 }}
                          />
                        }
                        classes={{
                          label: classes.label,
                          root: classes.labelRoot,
                        }}
                        label={i + 1}
                      />
                    </div>
                  </Fragment>,
                  restriction.zone_description,
                  restriction.canal_description,
                  restriction.advance,
                  <Fragment>
                    <div
                      className={
                        classes.checkboxAndRadio + ' ' + classes.checkboxAndRadioHorizontal
                      }
                    >
                      <FormControlLabel
                        disabled={statePromo || restriction.state == 'I'}
                        control={
                          <Checkbox
                            tabIndex={-1}
                            onClick={() => {
                              updateRestrinctionInd(
                                restriction.id,
                                restriction.independent == 'Y' ? 'N' : 'Y',
                              );
                            }}
                            checked={restriction.independent == 'Y' ? true : false}
                            checkedIcon={<Check className={classes.checkedIcon} />}
                            icon={<Check className={classes.uncheckedIcon} />}
                            classes={{
                              checked: classes.checked,
                              root: classes.checkRoot,
                            }}
                            style={{ marginTop: 0 }}
                          />
                        }
                        classes={{
                          label: classes.label,
                          root: classes.labelRoot,
                        }}
                      />
                    </div>
                  </Fragment>,
                  <TextField
                    type="date"
                    name="start_date"
                    onChange={(e) => handleChange(e, restriction.id)}
                    onBlur={() => saveUpdate(restriction.id)}
                    disabled={restriction.independent == 'N'}
                    value={restriction.updated_start_date || restriction.start_date || ''}
                    inputProps={{ max: restriction.end_date }}
                  />,
                  <TextField
                    type="date"
                    name="end_date"
                    onChange={(e) => handleChange(e, restriction.id)}
                    onBlur={() => saveUpdate(restriction.id)}
                    disabled={restriction.independent == 'N'}
                    inputProps={{ min: restriction.start_date }}
                    value={restriction.updated_end_date || restriction.end_date || ''}
                  />,
                  <TextField
                    type="number"
                    name="limit"
                    disabled={restriction.independent == 'N'}
                    onChange={(e) => handleChange(e, restriction.id)}
                    onBlur={() => saveUpdate(restriction.id)}
                    value={restriction.updated_limit || restriction.limit || ''}
                  />,
                ];
              })}
            />
          </div>
        </CardBody>
      </Card>
    </GridItem>
  );
}
